






























































































































































































import { Vue } from 'vue-property-decorator'
import { StockOutPlanServiceProxy } from '@/service-proxies/app-v2/wms.service-proxies'
import { getUserInfo } from '@/utils/auth'
import dayjs from 'dayjs'
import { setLocalStorage } from '@/utils/storage'
const sopsp = new StockOutPlanServiceProxy()

const columns = [
  {
    title: 'actions',
    dataIndex: 'actions',
    scopedSlots: { customRender: 'actions' },
    ellipsis: true,
    width: 80
  },
  {
    title: 'page_business_material_code',
    dataIndex: 'materialCode',
    scopedSlots: { customRender: 'materialCode' },
    ellipsis: true,
    width: 150
  },
  {
    title: 'page_business_material_name',
    dataIndex: 'materialName',
    scopedSlots: { customRender: 'materialName' },
    ellipsis: true,
    width: 150
  },
  {
    title: 'page_job_make_delivery_plan_quantity',
    dataIndex: 'planNum',
    scopedSlots: { customRender: 'planNum' },
    ellipsis: true,
    width: 150
  },
  {
    title: 'page_job_make_delivery_rea_plan_quantity',
    dataIndex: 'plannedNum',
    scopedSlots: { customRender: 'plannedNum' },
    ellipsis: true,
    width: 150
  },
  {
    title: 'page_job_make_delivery_inventory_quantity',
    dataIndex: 'totalNum',
    scopedSlots: { customRender: 'totalNum' },
    ellipsis: true,
    width: 150
  },
  {
    title: 'page_job_make_delivery_quantity_be_issued',
    dataIndex: 'toBeDeliveredNum',
    scopedSlots: { customRender: 'toBeDeliveredNum' },
    ellipsis: true,
    width: 150
  },
  {
    title: 'page_job_make_delivery_demand_quantity',
    dataIndex: 'requireNum',
    scopedSlots: { customRender: 'requireNum' },
    ellipsis: true,
    width: 150
  }
]
export default Vue.extend({
  data() {
    return {
      form: this.$form.createForm(this),
      dataSource: [],
      materialList: [], // 库位列表
      loading: false,
      count: 0,
      isPrint: false // 打印领料单
    }
  },
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    employeesList: {
      type: Array,
      default: () => []
    },
    plan: {
      type: Object,
      default: () => ({})
    }
  },
  watch: {
    visible: {
      handler() {
        if (this.visible) {
          this.dataSource = []
          sopsp.getPlanMaterialForStockOutPlan(this.plan.id).then((res) => {
            this.materialList = res
          })
        }
      },
      deep: true,
      immediate: true
    }
  },
  computed: {
    columns() {
      return columns.map((item) => {
        return {
          ...item,
          title: this.$t(item.title)
        }
      })
    }
  },
  methods: {
    disabledDate(current) {
      // Can not select days before today and today
      return current && current < dayjs().subtract(1, 'day')
    },
    dayjsTime(time) {
      return dayjs(time).format('YYYY-MM-DD')
    },
    handleDelete(record) {
      const dataSource = [...this.dataSource]
      this.dataSource = dataSource.filter((item) => item.key !== record.key)
    },
    addMaterial() {
      const { count, dataSource } = this
      const newData = {
        key: count,
        materialId: '',
        materialCode: '',
        materialName: '',
        planMaterialId: '',
        planNum: 0,
        plannedNum: 0,
        totalNum: 0,
        toBeDeliveredNum: 0,
        requireNum: 0,
        maxrequireNum: 0
      }
      this.dataSource = [...dataSource, newData]
      this.count = count + 1
    },
    handleChangeCode(value, record) {
      const dda = this.dataSource.find((res) => res.materialId === value)
      if (dda) {
        this.$message.warning(this.$t('page_job_make_delivery_duplicate_material'))
        return
      }
      const newData = [...this.dataSource]
      let target = newData.find((item) => record.key === item.key)
      const material = this.materialList.find((res) => res.materialId === value)
      if (target) {
        target.materialId = material.materialId
        target.planMaterialId = material.planMaterialId
        target.materialCode = material.materialCode
        target.materialName = material.materialName
        target.planNum = material.planNum
        target.plannedNum = material.plannedNum
        target.totalNum = material.totalNum
        target.toBeDeliveredNum = material.requireNum
        target.requireNum = material.requireNum
        target.maxrequireNum = material.requireNum
        this.dataSource = newData
        console.log(this.dataSource)
      }
    },
    handleChange(value, record, column) {
      const newData = [...this.dataSource]
      const target = newData.filter((item) => record.key === item.key)[0]
      if (target) {
        target[column] = value
        this.dataSource = newData
      }
    },
    close() {
      this.form.resetFields()
      this.isPrint = false
      this.dataSource = []
      this.$emit('close')
    },
    save() {
      const list = this.dataSource.filter((res) => res.materialId != '')
      if (list.length === 0) {
        this.$message.warning(this.$t('page_job_make_delivery_select_material'))
        return
      }
      this.form.validateFields((err, values) => {
        if (!err) {
          const stockOutUserCodeList = []
          const stockOutUserNameList = []
          this.employeesList.forEach((item) => {
            if (values.stockOutUserIdList.includes(item.id)) {
              stockOutUserCodeList.push(item.code)
              stockOutUserNameList.push(item.name)
            }
          })
          const data: any = {
            bomId: this.plan.bomId,
            bomVersion: this.plan.bomVersion,
            craftId: this.plan.craftId,
            craftVersion: this.plan.craftVersion,
            list: list,
            planCode: this.plan.code,
            planId: this.plan.id,
            planStartTime: this.plan.planStartTime
              ? dayjs(this.plan.planStartTime).format('YYYY-MM-DD')
              : undefined,
            planStockOutTime: dayjs(values.planStockOutTime).format('YYYY-MM-DD'),
            productCode: this.plan.productCode,
            productName: this.plan.productName,
            standardModel: this.plan.standardModel,
            code: values.code,
            stockOutUserCodeList: stockOutUserCodeList,
            stockOutUserIdList: values.stockOutUserIdList,
            stockOutUserNameList: stockOutUserNameList
          }
          sopsp.createStockOutPlan(data).then((res) => {
            data.code = res
            data.orderCode = this.plan.orderCode
            data.stockOutUserNameList = data.stockOutUserNameList.length
              ? data.stockOutUserNameList.join(',')
              : ''
            this.$store.state.cardPrintData = data
            setLocalStorage('cardPrintData', data)
            this.isPrint = true
          })
        }
      })
    },
    print() {
      this.form.resetFields()
      this.isPrint = false
      this.dataSource = []
      this.$emit('close')
      window.open('/deLivery/point')
    }
  }
})
